<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Employee Name</th>
          <th class="text-center">Leave Policy</th>
          <th class="text-center">Number Of Days</th>
          <th class="text-center">Date From</th>
          <th class="text-center">Date To</th>
          <th class="text-center">Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td> {{ item.contact_profile_name }}</td>
          <td class="text-center">{{ item.leave_policy_name }}</td>
          <td class="text-center">{{ item.number_of_days }}</td>
          <td class="text-center">{{ item.date_from }}</td>
          <td class="text-center">{{ item.date_to }}</td>
          <td class="text-center">{{ item.status }}</td>
          <td>
            <button class="btn btn-primary btn-sm"
                    @click="goToEdit(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
            <button v-if="item.leave_applications_count < 1" :disabled="loading" @click="deleteItem(item)" class="btn btn-outline-danger btn-sm print-btn mx-1">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {inject, ref} from "vue";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const props  = defineProps({
  tableItems     : Object,
  onDelete: {
    type: Function,
    default: () => {}
  }
});
const route  = useRoute();
const router = useRouter();
const loading = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const $emit = defineEmits(['onDelete'])
const {
  deleteLeaveBalance
} = handleHrPayroll()

const deleteItem = async (item) => {
  if(!confirm('Are you sure you want to delete this leave balance?')) return;
  const query = '?company_id=' + route.params.companyId;
  loading.value = true

  try {
    let res = await deleteLeaveBalance(query, item.id);
    if (!res.status) {
      showError(res.message);
      return;
    }
    $emit('onDelete');
    showSuccess(res.message)
  } catch (err) {
    if (!err.response) {
      showError('Something is wrong. Check your connectivity!!');
      return;
    }
    showError(err.response.message)
  } finally {
    loading.value = false
  }
}

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.leaveBalanceId = item.id;

  router.push({
    name:  'leave-balance-add',
    params: param,
    query: query
  })
}
</script>
